/* eslint-disable import/prefer-default-export */
export const GET_CONNECTED_DEDICATED_CUSTOMERS_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
